type CheckoutQuestionnaireHeaderPatternProps = {
	className?: string;
};

export function CheckoutQuestionnaireHeaderPattern({
	className,
}: CheckoutQuestionnaireHeaderPatternProps) {
	return (
		<svg
			width="268"
			height="233"
			viewBox="0 0 268 233"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
			className={className}
		>
			<defs>
				<path
					id="checkout-questionnaire-header-leaf"
					d="M24.093 0C19.313 0 15.106.892 11.469 2.672 7.839 4.462 5.018 7.098 3.012 10.609 1 14.116 0 18.414 0 23.5c0 3.808.572 7.177 1.72 10.097 1.143 2.931 2.789 5.387 4.938 7.393 2.149 2.007 4.69 3.507 7.622 4.51 2.937.993 6.208 1.5 9.823 1.5H32V0h-7.907Z"
				/>
			</defs>
			<g fill="currentColor">
				<use href="#checkout-questionnaire-header-leaf" />
				<use href="#checkout-questionnaire-header-leaf" x="67" />
				<use href="#checkout-questionnaire-header-leaf" x="134" />
				<use href="#checkout-questionnaire-header-leaf" x="201" />
				<use href="#checkout-questionnaire-header-leaf" x="35" y="62" />
				<use href="#checkout-questionnaire-header-leaf" x="102" y="62" />
				<use href="#checkout-questionnaire-header-leaf" x="169" y="62" />
				<use href="#checkout-questionnaire-header-leaf" x="236" y="62" />
				<use href="#checkout-questionnaire-header-leaf" y="124" />
				<use href="#checkout-questionnaire-header-leaf" x="67" y="124" />
				<use href="#checkout-questionnaire-header-leaf" x="134" y="124" />
				<use href="#checkout-questionnaire-header-leaf" x="201" y="124" />
				<use href="#checkout-questionnaire-header-leaf" x="35" y="186" />
				<use href="#checkout-questionnaire-header-leaf" x="102" y="186" />
				<use href="#checkout-questionnaire-header-leaf" x="169" y="186" />
				<use href="#checkout-questionnaire-header-leaf" x="236" y="186" />
			</g>
		</svg>
	);
}
